export const menuLinks = [
  { id: 'Work', label: 'Work', path: '/' },
  { id: 'About', label: 'About Me', path: '/about' },
  { id: 'Contact', label: 'Contact', path: '/contact' },
];
